import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
// import VideoCover from 'react-video-cover';
import { Link } from 'react-router-dom';
import Search from '../../Search/Search';
// import customizationStyle from '../../../themeCustomizationClasses';
import { isSmartphone } from '../../../helpers';
import LocalizedStrings from '../../Localization/localization';
import AppContext from '../../../AppContext';
import CachedImage from '../../Common/CachedImage';
import { Button } from '@material-ui/core';
import PromotedSection from './PromotedSection';
import './Home.css';

const AdapterLink = React.forwardRef((props, ref) => <Link innerRef={ref} {...props} />);

class Home extends Component {
    state = {
        editing: false,
    };

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    componentDidMount() {
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
    }

    componentWillUnmount() {
        this.removeListener();
    }

    // resetSearch = () => {
    //     this.setState({ editing: false, });
    // }

    onEditingChange = (newEditing) => {
        this.setState({ editing: newEditing });
    };

    renderQuote = () => {
        if (this.state.editing) {
            return '';
        }
        let appContext = new AppContext();
        let platformConfig = appContext.getPlatformConfig();
        // console.log('platformConfig', platformConfig)
        let quote = platformConfig.homeQuote;
        let aux = quote.split('|');

        let containerStyle = {
            position: 'absolute',
            top: platformConfig.secondaryLogo === true ? '120px' : '80px',
            left: this.state.smartphoneView === true ? '0px' : '145px',
            width: 'calc(90% - 180px)',
            textAlign: 'left',
            color: platformConfig.customStyles.charlyHomeColor,
            fontSize: '30px',
        };
        if (this.state.smartphoneView === true) {
            containerStyle = {
                position: 'relative',
                zIndex: 2,
                marginTop: '100px',
                textAlign: 'left',
                color: platformConfig.customStyles.charlyHomeColor,
                fontSize: '20px',
            };
        }

        return (
            <div style={containerStyle} className="Home-quote">
                {aux.map((sentence) => {
                    return (
                        <div key={sentence}>
                            <div
                                style={{
                                    backgroundColor: '#fff',
                                    display: 'inline-block',
                                    padding: '2px 20px',
                                    marginTop: '5px',
                                }}
                            >
                                {sentence}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    renderGreeting = () => {
        let className = 'Home-welcome';
        if (this.state.editing) {
            className += ' Home-welcome-hidden';
        }
        let appContext = new AppContext();
        let myInfo = appContext.getMyInfo();

        return (
            <div
                className={className}
                style={{
                    textAlign: 'left',
                    fontSize: this.state.smartphoneView === true ? '2em' : '3em',
                }}
            >
                {LocalizedStrings.hi} {myInfo.name}
                {','}
            </div>
        );
    };

    handleOpenResource = (resource, evt, source) => {
        if (resource.resourceType === 'file') {
            this.props.openFileViewer(resource.resourceId, resource.resourceSubtype, undefined, source);
        } else if (resource.resourceType === 'content') {
            this.props.openContent(resource.resourceId, resource.resourceSubtype, 'show', evt, source);
        } else {
            console.warn('Implement open callback');
            //TODO: implement actions to open everything
        }
    };

    renderTopContent = () => {
        if (this.state.editing) {
            return '';
        }
        return <PromotedSection onOpenResource={this.handleOpenResource} />;
    };

    render() {
        let appContext = new AppContext();
        let platformConfig = appContext.getPlatformConfig();
        let homeColor = platformConfig.homeColor !== undefined ? platformConfig.homeColor : true;
        let homeHeader = platformConfig.homeHeader !== undefined ? platformConfig.homeHeader : false;

        let fontColor = this.props.fontColor;
        if (homeHeader === true) {
            fontColor = platformConfig.customStyles.charlyHomeColor;
        }

        const searchStyle = {
            field: {
                color: fontColor,
                width: this.state.editing === true ? '100%' : '100%',
            },
            iconStyle: {
                color: fontColor,
                size: '32px',
            },
        };

        let auxStyle;
        if (this.state.editing === true || this.state.smartphoneView === true) {
            auxStyle = { margin: 'auto' };
        } else {
            auxStyle = { marginLeft: '20px' };
        }

        return (
            <Fragment>
                {homeHeader === true ? (
                    homeColor === true ? (
                        this.state.editing !== true && (
                            <div
                                className={`home-header-background ${this.props.backgroundColor}`}
                                style={{
                                    left: this.state.smartphoneView === true ? '0px' : '145px',
                                }}
                            />
                        )
                    ) : (
                        this.state.editing !== true && (
                            <CachedImage
                                imageKey="home-background"
                                platformId={appContext.getPlatformId()}
                                fileName={'home-background.png'}
                                renderElement={(src) => (
                                    <div
                                        className={'home-header-background home-header-background-image'}
                                        style={{
                                            backgroundImage: `url(${src})`,
                                            left: this.state.smartphoneView === true ? '0px' : '145px',
                                        }}
                                    />
                                )}
                            />
                        )
                    )
                ) : homeColor === true ? (
                    <div className={`App-page-background ${this.props.backgroundColor}`} />
                ) : (
                    <CachedImage
                        imageKey="home-background"
                        platformId={appContext.getPlatformId()}
                        fileName={'home-background.png'}
                        renderElement={(src) => (
                            <div
                                className={'App-page-background home-header-background-image'}
                                style={{ backgroundImage: `url(${src})` }}
                            />
                        )}
                    />
                )}
                <div style={{ textAlign: 'left', color: fontColor }}>
                    {platformConfig.secondaryLogo === true && (
                        <CachedImage
                            imageKey="secondary-logo"
                            platformId={appContext.getPlatformId()}
                            fileName={this.props.customization.secondaryLogo}
                            renderElement={(src) => (
                                <div
                                    className={`${this.state.editing !== true ? 'Home-secondary-logo' : 'Home-secondary-logo-results'} ${
                                        this.state.smartphoneView === true ? 'Home-secondary-smartphone' : ''
                                    }`}
                                    style={{ backgroundImage: `url(${src})` }}
                                />
                            )}
                        />
                    )}
                    {this.renderQuote()}
                    <CachedImage
                        imageKey="logo-negative"
                        platformId={appContext.getPlatformId()}
                        fileName={this.props.customization.logoNegative}
                        renderElement={(src) => (
                            <div
                                className={`Home-logo ${this.state.editing === true ? 'Home-logo-results' : ''} Home-logo-stick`}
                                style={{ backgroundImage: `url(${src})` }}
                            />
                        )}
                    />
                    <div
                        className={
                            this.state.editing === true
                                ? 'Home-container-with-scroll'
                                : this.state.smartphoneView === true
                                ? 'Home-container-smartphone'
                                : 'Home-container'
                        }
                        style={
                            this.state.smartphoneView !== true
                                ? {
                                      ...auxStyle,
                                      width: `calc(90% - ${this.state.editing === true ? '0px' : '150px'})`,
                                  }
                                : undefined
                        }
                    >
                        {this.renderGreeting()}
                        <Search
                            notify={this.props.notify}
                            editing={this.state.editing}
                            onEditingChange={this.onEditingChange}
                            searchStyle={searchStyle}
                            onResultSelected={this.handleOpenResource}
                            disabled={this.props.isOnline !== true}
                            theme={homeHeader === true ? undefined : 'light'}
                            containerStyle={
                                this.state.smartphoneView === true
                                    ? { marginBottom: '20px' }
                                    : {
                                          display: 'inline-block',
                                          width: this.state.editing === true ? '100%' : 'calc(100% - 180px)',
                                          marginRight: this.state.editing === true ? '0px' : '20px',
                                      }
                            }
                        />
                        {this.state.editing === false && (
                            <Button color="default" variant="contained" component={AdapterLink} to="/category/show">
                                {LocalizedStrings.accessInside}
                            </Button>
                        )}
                        {this.props.isOnline !== true && <div style={{ color: fontColor }}>{LocalizedStrings.searchOfflineError}</div>}
                    </div>
                    {this.renderTopContent()}
                </div>
            </Fragment>
        );
    }
}
// falta canviar opacitat dels colors de la cerca
Home.propTypes = {
    notify: PropTypes.func,
    customization: PropTypes.object.isRequired,
    openContent: PropTypes.func.isRequired,
    openFileViewer: PropTypes.func.isRequired,
    fontColor: PropTypes.string.isRequired,
    isOnline: PropTypes.bool,
    backgroundColor: PropTypes.string.isRequired,
};

export default Home;
